import { Dialog } from 'primereact/dialog';
import { Typography, SecondaryButton } from '@uni-of-exeter/digital.lib.react.ui.kit';

import './session-expired.css';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SessionExpiredDialog: React.FC<DialogProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      aria-hidden={!isOpen}
      header={<Typography variant="h2.bold">Session Expired</Typography>}
      footer={
        <SecondaryButton
          aria-label={'OK'}
          label="OK"
          onClick={onClose}
        />
      }
      className="dialog"
      modal={true}
      closable={false}
      resizable={false}
      draggable={false}
      focusOnShow={false}
    >
      <Typography
        variant="body"
        aria-modal
        role="alertdialog"
        aria-label="Session Expired"
      >
        Your session has expired, please refresh the page or close this dialog to continue.
      </Typography>
    </Dialog>
  );
};
